import { useEffect, useRef, useState } from 'react';
import { Button, TextField, Grid, Box, Typography, Alert, FormControl, InputLabel, Select, MenuItem, Autocomplete, Switch, FormControlLabel, Divider } from '@mui/material';
import { formToJson, getUserSession, minuteToTime, timeToMinutes } from '../../../Utils/Common';
import Container from '@mui/material/Container';
import CssBaseline from '@mui/material/CssBaseline';
import apis from '../../../api';
import { CoachLoader, CoachSelect } from '../../fragement/CoachSelector';
import { CourseCode, WeekDays } from '../../../Utils/Dict';
import { SingleSelector } from '../../../Component/MuiEx';
import { loadClassroom, settingDataLoader } from '../../../Component/DataLoader';
import ClassroomSelector from '../../fragement/ClassroomSelector';
import { CourseLoader, CourseSelect } from '../../fragement/CourseSelector';
import CourseCategorySelector from '../../fragement/CourseCategorySelector';

const EditClass = (props) => {
    const { data, onSubmit, onClose } = props
    const [fieldErrors, setFieldErrors] = useState()
    const [error, setError] = useState()
    const [weekDate, setWeekDate] = useState(data?.week_date)
    const [settle,setSettle] = useState(data?.teacher_settle_type)
    const [attendance,setAttendance] = useState(data?.teacher_base_attend)
    const [originalPrice,setOriginalPrice] = useState(data?.teacher_base_original_price)
    const [includeFree,setIncludeFree] = useState(data?.teacher_include_free)
    const [classrooms, setClassrooms] = useState()
    const [roomid,setRoomid] = useState(data?.room_id)
    const [coaches, setCoaches] = useState()   
    const [fields, setFields] = useState({ teacher_id: data?.teacher_id, assistant_id: data?.assistant_id,category_id:data?.category_id })
    getUserSession(apis)
    const inputRef = useRef()
    const setTextInputRef = (element) => {
        inputRef.current = element;
    };
    let loading = false
    useEffect(() => {
        if(loading) return
        loading = true
        settingDataLoader('classroom',1,apis,(datas) => {
            setClassrooms(datas)
        }, setError)
        CoachLoader((datas) => {
            setCoaches(datas)
        }, apis)        
    }, [])
    const handleWeekdayChange = (name, value) => {
        setWeekDate(value)
    }
    const handleSubmit = (event) => {
        setFieldErrors()
        setError()
        event.preventDefault();

        const form = new FormData(event.currentTarget);
        const postData = formToJson(form)
        postData.id = data ? data.id : 0
        postData.week_date = weekDate
        postData.begin_time = timeToMinutes(postData.begin_time)
        postData.end_time = timeToMinutes(postData.end_time)
        postData.teacher_settle_type = settle
        postData.teacher_base_attend = attendance
        postData.teacher_base_original_price = originalPrice
        postData.teacher_include_free = includeFree
       
        // if (fields.course_id > 0) {
        //     postData.course_id = fields.course_id
        // } else {
        //     setError("You should select a course")
        //     return
        // }
        if (fields.teacher_id > 0) {
            postData.teacher_id = fields.teacher_id
        } else {
            setError("You should select a teacher")
            return
        }
        if (fields.assistant_id > 0) {
            postData.assistant_id = fields.assistant_id
        } else {
            postData.assistant_id = 0
        }
        // if (fields.classtype) {
        //     postData.classtype = fields.classtype
        // } else {
        //     postData.classtype = data?.classtype
        // }        
        postData.category_id = fields.category_id
        postData.room_id = roomid    
        onSubmit && onSubmit(postData, setError, setFieldErrors)
    };
    return (
        <Container component="main" maxWidth="sm">
            <CssBaseline />
            <Box sx={{ marginTop: 12, display: 'flex', flexDirection: 'column', alignItems: 'center', }}>
                <Typography component="h1" variant="h5">Add & Edit Class</Typography>
                <Box component="form" onSubmit={handleSubmit} sx={{ mt: 3 }} autoComplete="off">
                    <Grid container spacing={2}>
                        <Grid item xs={12} sm={4}>
                            <TextField defaultValue={data?.name} name="name" required fullWidth id="name" label="Class name"
                                error={fieldErrors && fieldErrors.name ? true : false}
                                helperText={fieldErrors && fieldErrors.name ? fieldErrors.name : ''}
                                autoFocus />
                        </Grid>
                        <Grid item xs={12} sm={4}>
                            <CourseCategorySelector defaultValue={fields.category_id} name={"category_id"} onChange={(k, v) => { setFields({ ...fields, category_id: v != null ? v.id : 0}); }} />
                        </Grid>                         
                        <Grid item xs={12} sm={4}>
                            {coaches && <CoachSelect label="Select a teacher" coaches={coaches} defaultValue={data?.teacher_id} name={"teacher"} onChange={(k, v) => { setFields({ ...fields, teacher_id: v != null ? v.id : 0 }) }} />}
                        </Grid>
                        <Grid item xs={12}><Divider /></Grid>   
                        <Grid item xs={12} sm={12}>
                            <SingleSelector labelSize="12px" label={"Teacher Settlement Rules"} defaultValue={data?.teacher_settle_type} items={["Fixed Fee","Commission","Headcount"]} values={[0,1,2]} onChange={(n,v)=>setSettle(v)} />
                        </Grid>
                        <Grid item xs={12} sm={4}>
                            <TextField name="teacher_base_fee" fullWidth id="teacher_base_fee" label="Teacher Guaranteed Fee" defaultValue={data?.teacher_base_fee} InputLabelProps={{ shrink: true }} required
                                error={fieldErrors && fieldErrors.teacher_base_fee ? true : false}
                                helperText={fieldErrors && fieldErrors.teacher_base_fee ? fieldErrors.teacher_base_fee : ''}
                            />
                        </Grid>
                        {settle == 1 && <Grid item xs={12} sm={4}>
                            <TextField name="teacher_divided_rate" fullWidth id="teacher_divided_rate" label="Teacher Divided Rate" defaultValue={data?.teacher_divided_rate} InputLabelProps={{ shrink: true }} required
                                error={fieldErrors && fieldErrors.teacher_divided_rate ? true : false}
                                helperText={fieldErrors && fieldErrors.teacher_divided_rate ? fieldErrors.teacher_divided_rate : ''}
                            />
                        </Grid>}
                        
                        {(settle == 2) && <Grid item xs={12} sm={4}>
                            <TextField name="teacher_base_students" type="number" fullWidth id="teacher_base_students" label="Guaranteed Students" defaultValue={data?.teacher_base_students} InputLabelProps={{ shrink: true }} required
                                error={fieldErrors && fieldErrors.teacher_base_students ? true : false}
                                helperText={fieldErrors && fieldErrors.teacher_base_students ? fieldErrors.teacher_base_students : ''}
                            />
                        </Grid>} 
                        {(settle == 2) && <Grid item xs={12} sm={4}>
                            <TextField name="teacher_fee_perstudents" fullWidth id="teacher_fee_perstudents" label="Additional per student fee" defaultValue={data?.teacher_fee_perstudents} InputLabelProps={{ shrink: true }} required
                                error={fieldErrors && fieldErrors.teacher_fee_perstudents ? true : false}
                                helperText={fieldErrors && fieldErrors.teacher_fee_perstudents ? fieldErrors.teacher_fee_perstudents : ''}
                            />
                        </Grid>}
                        <Grid item xs={12}><Divider /></Grid>     
                        {(settle == 1 || settle == 2) && <Grid item xs={12} sm={4}>
                            <FormControlLabel control={<Switch defaultChecked={attendance==1} size={"small"} />} size={"12px"} sx={{fontSize:"12px"}} label="Base Attendance" onChange={(e)=>{setAttendance(e.target.checked?1:0)}}/>
                        </Grid>}
                        {(settle == 1 || settle == 2) && <Grid item xs={12} sm={4}>
                            <FormControlLabel control={<Switch defaultChecked={originalPrice==1} size={"small"}  />} label="List-price-based" onChange={(e)=>{setOriginalPrice(e.target.checked?1:0)}}/>
                        </Grid>}
                        {(settle == 1 || settle == 2) && <Grid item xs={12} sm={4}>
                            <FormControlLabel control={<Switch defaultChecked={includeFree==1} size={"small"}  />} label="Pay free lesson" onChange={(e)=>{setIncludeFree(e.target.checked?1:0)}}/>
                        </Grid>}                  
                        <Grid item xs={12}><Divider /></Grid>
                        <Grid item xs={12} sm={4}>                            
                            {coaches && <CoachSelect label="Select a teacher assistant" coaches={coaches} defaultValue={data?.assistant_id} onChange={(k, v) => { setFields({ ...fields, assistant_id: v != null ? v.id : 0 }) }} />}
                        </Grid>
                        <Grid item xs={12} sm={4}>
                            <TextField name="assistant_fee" fullWidth id="assistant_fee" label="Assistant fee" defaultValue={data?.assistant_fee} InputLabelProps={{ shrink: true }} required
                                error={fieldErrors && fieldErrors.assistant_fee ? true : false}
                                helperText={fieldErrors && fieldErrors.assistant_fee ? fieldErrors.assistant_fee : ''}
                            />
                        </Grid>                        
                        <Grid item xs={12}><Divider /></Grid>
                        
                        <Grid item xs={12} sm={4}>
                            <Autocomplete disablePortal id="week-day-selector"
                                options={WeekDays}
                                autoComplete
                                autoHighlight
                                autoSelect
                                onChange={(_event, newitem) => { handleWeekdayChange('customer', WeekDays.indexOf(newitem)) }}
                                defaultValue={data && WeekDays[data.week_date]}
                                renderInput={(params) => <TextField {...params} label="Week Day" inputRef={setTextInputRef} />}
                            />
                        </Grid>
                        <Grid item xs={12} sm={4}>
                            <TextField name="begin_time" type="time" required fullWidth id="begin_time" label="Begin time" defaultValue={data && minuteToTime(data.begin_time)}
                                error={fieldErrors && fieldErrors.begin_time ? true : false}
                                helperText={fieldErrors && fieldErrors.begin_time ? fieldErrors.begin_time : ''}
                            />
                        </Grid>
                        <Grid item xs={12} sm={4}>
                            <TextField name="end_time" type="time" fullWidth required id="end_time" label="End time" defaultValue={data && minuteToTime(data.end_time)}
                                error={fieldErrors && fieldErrors.end_time ? true : false}
                                helperText={fieldErrors && fieldErrors.end_time ? fieldErrors.end_time : ''}
                            />
                        </Grid>  
                        <Grid item xs={12} sm={4}>
                            {classrooms && <ClassroomSelector label={"Classroom select"} classrooms={classrooms} defaultValue={roomid} name={"room_id"} onChange={(k, v) => { setRoomid(v != null ? v.id : 0)}} />}
                        </Grid>
                        <Grid item xs={12} sm={8}>
                            <TextField defaultValue={data?.note} name="note" fullWidth id="note" label="Note"
                                error={fieldErrors && fieldErrors.note ? true : false}
                                helperText={fieldErrors && fieldErrors.note ? fieldErrors.note : ''}
                            />
                        </Grid>
                    </Grid>
                    {error && <Alert severity="error" onClose={() => { setError() }}>{error}</Alert>}
                    <Grid container>
                        <Grid item xs={12} sm={6}>
                            <Button type="submit" fullWidth variant="contained" sx={{ mt: 2, mb: 2 }} > Submit </Button>
                        </Grid>
                        <Grid item xs={12} sm={6}>
                            <Button type="button" fullWidth variant="outlined" sx={{ mt: 2, mb: 2 }} onClick={() => { props.onClose && props.onClose(false) }}> Cancel </Button>
                        </Grid>
                    </Grid>
                </Box>
            </Box>
        </Container>
    );
}
export default EditClass